<template>
    <div>
        <CFTitle title="25. Buget - Plan anual de cheltuieli"></CFTitle>
        <div class="table-margin">
            <b-table responsive :fields="fields" :items="items" thead-class="blue-head"></b-table>
        </div>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BTable, BFormInput, BIconXCircleFill, BIconPlusCircleFill, BFormCheckbox, BFormGroup } from 'bootstrap-vue'
    require('@/helpers/validations/validations')
    export default {
        components: {
            CFTitle, BTable, BFormInput, BIconXCircleFill, BIconPlusCircleFill, BFormCheckbox, BFormGroup
        },
        props: {
            bugetData: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'componenta',
                        label: 'Componentă',
                    },
                    {
                        key: '2014',
                        label: '2014',
                    },
                    {
                        key: '2015',
                        label: '2015',
                    },
                    {
                        key: '2016',
                        label: '2016',
                    },
                    {
                        key: '2017',
                        label: '2017',
                    },
                    {
                        key: '2018',
                        label: '2018',
                    },
                    {
                        key: '2019',
                        label: '2019',
                    },
                    {
                        key: '2020',
                        label: '2020',
                    },
                    {
                        key: '2021',
                        label: '2021',
                    },
                    {
                        key: '2022',
                        label: '2022',
                    },
                    {
                        key: '2023',
                        label: '2023',
                    },
                ],
                items: [
                    {
                        componenta: 'Componentă 1',
                        2014: '0.00',
                        2015: '0.00',
                        2016: '0.00',
                        2017: '0.00',
                        2018: '0.00',
                        2019: '0.00',
                        2020: '0.00',
                        2021: '0.00',
                        2022: '0.00',
                        2023: '0.00'
                    }
                ]
            }
        },
        mounted() {
            if(this.bugetData){
                this.items[0][2022] = this.bugetData && this.bugetData.first_year_total ? this.bugetData.first_year_total.RON : '0.00'
                this.items[0][2023] = this.bugetData && this.bugetData.second_year_total ? this.bugetData.second_year_total.RON : '0.00'
                this.$store.dispatch('finantare/addToProgress', 'Buget - Plan anual de cheltuieli')
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
.table-margin{
    margin-top: 40px;
}
table >>> .blue-head{
    background: #bdd6ee;
    text-align: center;
}
table >>> th, table >>> td{
    border: 1px solid #979696;
    font-size: 14px;
}
</style>